import {
  ObjectCondition,
  ObjectTrigger,
  SceneThermostatState,
  SceneStateComparer,
  SceneThermostatConditionState,
  SceneThermostatModalityState,
} from '@/../client-generator/generated-clients/plants';
import ProtocolConstants from '@/core/services/slots-assign-rules-service/protocol-constants';
import EnumToRadioButton from '@/views/components/EnumToRadioButton/EnumToRadioButton.vue';
import { Options } from 'vue-class-component';
import SceneTriggerAndConditionGeneral from '../SceneTriggerAndConditionGeneral';

@Options({
  name: 'TriggerAndConditionThermostat',
  components: {
    EnumToRadioButton,
  },
  watch: {
    'triggerOrActionToAdd.thermostatState': function () {
      this.thermostatStateChanged();
    },
    'triggerOrActionToAdd.stateComparer': function () {
      this.stateComparerChanged();
    },
  },
})
export default class TriggerAndConditionThermostat extends SceneTriggerAndConditionGeneral {
  SceneThermostatState = SceneThermostatState;
  SceneStateComparer = SceneStateComparer;
  SceneThermostatConditionState = SceneThermostatConditionState;
  SceneThermostatModalityState = SceneThermostatModalityState;
  declare triggerOrActionToAdd: ObjectTrigger | ObjectCondition;
  static readonly MinimumDimmerPercent = 1;
  sliderMin = ProtocolConstants.MinimumThermostatTemperature;
  sliderMax = ProtocolConstants.MaximumThermostatTemperature;

  get isStateComparerManagementAvailable() {
    return (
      this.triggerOrActionToAdd.thermostatState != SceneThermostatState.None
    );
  }

  get isTemperatureStateComparerManagementAvailable() {
    return (
      this.triggerOrActionToAdd.thermostatState ==
        SceneThermostatState.Temperature ||
      this.triggerOrActionToAdd.thermostatState ==
        SceneThermostatState.DesiredTemperature
    );
  }

  get isTemperatureManagementAvailable() {
    return (
      this.triggerOrActionToAdd.stateComparer != SceneStateComparer.None &&
      (this.triggerOrActionToAdd.thermostatState ==
        SceneThermostatState.Temperature ||
        this.triggerOrActionToAdd.thermostatState ==
          SceneThermostatState.DesiredTemperature)
    );
  }

  get isThermoConditionManagementAvailable() {
    return (
      this.triggerOrActionToAdd.stateComparer != SceneStateComparer.None &&
      this.triggerOrActionToAdd.thermostatState ==
        SceneThermostatState.Condition
    );
  }

  get isThermoModalityManagementAvailable() {
    return (
      this.triggerOrActionToAdd.stateComparer != SceneStateComparer.None &&
      this.triggerOrActionToAdd.thermostatState == SceneThermostatState.Modality
    );
  }

  get sceneStateComparerDisabledChoices() {
    if (
      this.isStateComparerManagementAvailable &&
      !this.isTemperatureStateComparerManagementAvailable
    ) {
      return [SceneStateComparer.Higher, SceneStateComparer.Lower];
    }
    if (
      !this.isStateComparerManagementAvailable &&
      this.isTemperatureStateComparerManagementAvailable
    ) {
      return [SceneStateComparer.Different, SceneStateComparer.Equal];
    }
    return [];
  }

  get isConfirmEnabled() {
    return true;
  }

  thermostatStateChanged() {
    this.triggerOrActionToAdd.stateComparer = SceneStateComparer.None;
  }

  stateComparerChanged() {
    this.triggerOrActionToAdd.thermostatTemperature = this.sliderMin;
  }
}
